import { apiRequest } from './client';
import type { TriageSession, TriageMode, TriageSessionStatus, PrRecord } from '@outlinked/shared';

// Re-export canonical types so consumers continue to import from here.
export type { TriageSession, TriageMode, TriageSessionStatus, PrRecord };

export interface TriageSessionsListResponse {
  items: TriageSession[];
  nextCursor: string | null;
}

export interface ListTriageSessionsOpts {
  status?: TriageSessionStatus;
  cursor?: string;
  limit?: number;
}

export function listTriageSessions(
  opts: ListTriageSessionsOpts = {},
): Promise<TriageSessionsListResponse> {
  const params = new URLSearchParams();
  if (opts.status) params.set('status', opts.status);
  if (opts.cursor) params.set('cursor', opts.cursor);
  if (opts.limit) params.set('limit', String(opts.limit));
  return apiRequest<TriageSessionsListResponse>(`/triage-sessions?${params}`);
}

export function getTriageSession(id: string): Promise<TriageSession> {
  return apiRequest<TriageSession>(`/triage-sessions/${id}`);
}

export function startTriageSession(body: {
  findingIds: string[];
  allowAutoMerge: boolean;
  mode?: TriageMode;
}): Promise<TriageSession> {
  return apiRequest<TriageSession>('/triage-sessions', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function stopTriageSession(id: string, reason?: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(`/triage-sessions/${id}/stop`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}

export function replyToSession(id: string, message: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(`/triage-sessions/${id}/reply`, {
    method: 'POST',
    body: JSON.stringify({ message }),
  });
}

export function enableAutoMerge(id: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(`/triage-sessions/${id}/auto-merge`, {
    method: 'POST',
  });
}
